import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const formatNum = (n) => {
  if (n >= 10000000) return `${(n / 10000000).toFixed(1)}Cr`;
  if (n >= 100000) return `${(n / 100000).toFixed(1)}L`;
  return `${(n / 1000).toFixed(0)}K`;
};

export default function RevenueTracker({ targets, categories }) {
  const chartData = categories.map(c => ({
    name: c.category,
    actual: Math.round(c.revenue),
    target: Math.round(c.target),
    pct: c.target > 0 ? Math.round((c.revenue / c.target) * 100) : 0,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const d = payload[0]?.payload;
    return (
      <div className="bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-xs shadow-xl">
        <p className="text-slate-300 font-medium">{d.name}</p>
        <p className="text-cyan-400">Actual: INR {formatNum(d.actual)}</p>
        <p className="text-slate-400">Target: INR {formatNum(d.target)}</p>
        <p className="text-emerald-400">Achievement: {d.pct}%</p>
      </div>
    );
  };

  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-6" data-testid="revenue-tracker">
      <h3 className="text-base font-semibold text-white mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Revenue vs Target</h3>
      <p className="text-xs text-slate-500 mb-4">By product category (YTD)</p>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={chartData} layout="vertical" margin={{ left: 10, right: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" horizontal={false} />
          <XAxis type="number" tick={{ fill: '#64748b', fontSize: 9 }} tickFormatter={v => formatNum(v)} axisLine={{ stroke: '#1e293b' }} />
          <YAxis dataKey="name" type="category" tick={{ fill: '#94a3b8', fontSize: 10 }} width={90} axisLine={{ stroke: '#1e293b' }} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="target" fill="#334155" radius={[0, 4, 4, 0]} barSize={14} name="Target" />
          <Bar dataKey="actual" fill="#22d3ee" radius={[0, 4, 4, 0]} barSize={14} name="Actual" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
